import { render } from "./DriverDetail.vue?vue&type=template&id=4240698c&scoped=true"
import script from "./DriverDetail.vue?vue&type=script&lang=js"
export * from "./DriverDetail.vue?vue&type=script&lang=js"

import "./DriverDetail.vue?vue&type=style&index=0&id=4240698c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4240698c"]])

export default __exports__